module.exports = __webpack_public_path__ + "img/tou2.e766217d.jpg";